export default __webpack_public_path__ + "static/media/rwx_user_img_mybackground.64bc12ae.png";